import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddMealNew from '../components/TrackerAddMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeCookbookMeal } from '../helpers/normalizers';
import { CookbookMealProps } from '../types';

const TrackerAddCookbookMealContainer: React.FC<CookbookMealProps> = (props) => {
  const normalizedProps = normalizeCookbookMeal(props);
  return (
    <TrackerAddMealNew
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      mode="backward-navigation"
    />
  );
};

export default withLoading(TrackerAddCookbookMealContainer, UniversalPlaceholder);
